module.exports = __webpack_public_path__ + "media/images/common/icon-arrow-right-f5ae834c7d51d8aa09d47417880cb2a6.svg";